import { useMutation, useQueryClient } from '@tanstack/react-query';
import LabService from '@/services/LabService';
import type { OrderLabInput } from '@/services/LabService';
import { TASK_KEYS } from '@/state/data/task/keys';
import { scheduleInvalidate } from '@/state/data/_shared/wf-race';

// Async via Tier 4 lab_order_requested → n8n. See _shared/wf-race.ts.

export function useOrderLabInElation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: OrderLabInput) => LabService.orderLabInElation(input),
    onSettled: () => scheduleInvalidate(qc, TASK_KEYS.all),
  });
}
